import { quoteOrTabRemoved } from 'epic/workspace/common/tabs/tabsEpics/quoteOrTabRemoved';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { merge, of } from 'rxjs';
import { delay, filter, mergeMap, takeUntil } from 'rxjs/operators';
import { addonQuoteStale } from 'state/addonForm/addonForm.action';
import * as actionTypes from 'state/addonForm/addonForm.actionTypes';
import type { EpicWithThunk } from 'state/state.common';

// TODO catch Error in Epic
export function tradeTimerEpic(appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$) =>
    action$.pipe(
      ofType(actionTypes.ADDON_QUOTE_RECEIVED),
      filter(action => action.quote.status === 'Quoted'),
      mergeMap(({ tabId, quoteId, timeToTradeInMs }) => {
        const quoteOrTabRemoved$ = quoteOrTabRemoved(action$, tabId, quoteId, state$);

        const tradeRequested$ = action$.pipe(
          ofType(actionTypes.ADDON_QUOTE_TRADE_REQUESTED),
          filter(action => action.tabId === tabId),
        );

        return of(addonQuoteStale(tabId, quoteId)).pipe(
          delay(timeToTradeInMs, appScheduler),
          takeUntil(merge(tradeRequested$, quoteOrTabRemoved$)),
        );
      }),
    );
}
